import React, { memo } from 'react';

import Popups from '../../components/Popup';

const DescriptionChangePopupContainer = ({ children }, { closePopup }) => (
  <>
    <Popups.DescriptionChangePopup onClick={closePopup} />
    {children}
  </>
);

export default memo(DescriptionChangePopupContainer);
